import {ColorInput, ColorInputProps, useSafeMantineTheme} from '@mantine/core'
import {ForwardedRef, forwardRef} from 'react'
import {twMerge} from 'tailwind-merge'

export const SColorInput = forwardRef(
  (
    {
      className,
      onChange: _onChange,
      value,
      ...props
    }: Omit<ColorInputProps, 'onChange'> & {onChange: (c: string | undefined | null) => void},
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    const {colors} = useSafeMantineTheme()
    return (
      <ColorInput
        ref={ref}
        className={twMerge(`w-[9em] shrink-0 grow-0 cursor-pointer`, className)}
        variant='filled'
        swatches={[
          colors.blue[5],
          colors.teal[5],
          colors.red[5],
          colors.gray[5],
          colors.green[5],
          colors.indigo[5],
          '#FFF',
          '#000'
        ]}
        onChange={c => {
          _onChange?.(c == '' ? null : c)
        }}
        value={value ?? ''}
        {...props}
      />
    )
  }
)
